export enum LogLevel {
  Info = "info",
  Warn = "warn",
  Error = "error"
}
